// src/pages/NotFoundPage.tsx
import { Home, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-orange-50/30 flex items-center justify-center p-4">
      <div className="text-center max-w-md">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <img src="/images/logo.png" className="h-12 w-auto" alt="Cabukaka" />
        </div>

        {/* Code erreur */}
        <div className="relative mb-8">
          <div className="text-9xl font-bold text-orange-600/20">404</div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-32 h-32 bg-orange-100 rounded-full flex items-center justify-center">
              <span className="text-5xl">🔍</span>
            </div>
          </div>
        </div>

        {/* Message */}
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Page non trouvée
        </h1>
        <p className="text-gray-500 mb-8">
          Oups ! La page que vous recherchez semble introuvable.
          Elle a peut-être été déplacée ou n'existe plus.
        </p>

        {/* Boutons */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center justify-center gap-2 px-6 py-3 border border-gray-300 rounded-xl text-gray-700 font-medium hover:bg-gray-50 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Retour
          </button>
          <button
            onClick={() => navigate('/')}
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-orange-600 hover:bg-orange-700 text-white font-medium rounded-xl transition-colors shadow-lg hover:shadow-xl"
          >
            <Home className="w-4 h-4" />
            Accueil
          </button>
        </div>

        {/* Liens utiles */}
        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-sm text-gray-500 mb-3">Vous pouvez aussi :</p>
          <div className="flex flex-wrap gap-3 justify-center text-sm">
            <a href="/login" className="text-orange-600 hover:underline">Se connecter</a>
            <span className="text-gray-300">•</span>
            <a href="/register" className="text-orange-600 hover:underline">Créer un compte</a>
            <span className="text-gray-300">•</span>
            <a href="/contact" className="text-orange-600 hover:underline">Contacter le support</a>
          </div>
        </div>
      </div>
    </div>
  );
}